module.exports = __webpack_public_path__ + "img/Edinburgh,_City_of.1d727c21.png";